import { useParams, Navigate } from "react-router-dom";
import { COMPONENTS } from "./registry";

/**
 * Renders the article for a slug at /blog/<slug>. Unknown slugs redirect to the
 * /blog index. (Legacy /gids/<slug> URLs are 301-redirected to /blog/<slug> at
 * the edge — see public/_redirects.)
 */
export function BlogPost() {
  const { slug } = useParams<{ slug: string }>();
  const Component = slug ? COMPONENTS[slug] : undefined;

  if (!Component) {
    return <Navigate to="/blog" replace />;
  }
  return <Component />;
}
